import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Button,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import Alerts from "components/Alerts";
import {
  GET_BUY_ORDER_BY_ID,
  UPDATE_ADMIN_BUY_ORDER_BY_ID,
} from "./QueryAdminLogistic";
import LoopIcon from '@mui/icons-material/Loop';
import { useApolloClient } from "@apollo/client";

const AssignBuyOrder = ({ id, params }) => {
  const {
    setAlertCustom,
    alertCustom,
    setNewAssignRequeriment,
    handleCloseModal,
  } = params;
  const client = useApolloClient();
  const [textFieldValue, setTextFieldValue] = useState('');
  const [visibility, setvisibility] = useState(false);
  const [saved, setsaved] = useState(true);
  const [buyorderRequeriment, setBuyorderRequeriment] = useState([]);
  useEffect(() => {
    const getBuyorderRequeriment = async (id) => {
      try {
        const { data } = await client.query({
          query: GET_BUY_ORDER_BY_ID,
          variables: {
            getBuyOrderByIdId: id,
          },
        });
        console.log(data.getBuyOrderById);
        setBuyorderRequeriment(data.getBuyOrderById);
        setvisibility(true);
      } catch (error) {
        console.log(error.message);
      }
    };
    getBuyorderRequeriment(id);
  }, []);
  const handlePersonalRequerimentReject = async () => {
    try {
      setsaved(false)
      const response = await client.mutate({
        mutation: UPDATE_ADMIN_BUY_ORDER_BY_ID,
        variables: {
          updateBuyOrderAdminId: id,
          type: 0,
          observation:textFieldValue
        },
      });
      console.log(response.data.updateBuyOrderAdmin);
      setNewAssignRequeriment(response.data.updateBuyOrderAdmin);

      setAlertCustom({
        type: "success",
        message: "Registro ingresado",
        state: true,
      });
      setsaved(true)
      handleCloseModal();
    } catch (error) {
      setAlertCustom({
        ...alertCustom,
        type: "error",
        message: error.message,
        state: true,
      });
    }
  };
  const handlePersonalRequerimentApproved = async () => {
    try {
      setsaved(false)
      const response = await client.mutate({
        mutation: UPDATE_ADMIN_BUY_ORDER_BY_ID,
        variables: {
          updateBuyOrderAdminId: id,
          type: 1,
          observation:textFieldValue
        },
      });
      console.log(response.data.updateBuyOrderAdmin);
      setNewAssignRequeriment(response.data.updateBuyOrderAdmin);

      setAlertCustom({
        type: "success",
        message: "Registro ingresado",
        state: true,
      });
      setsaved(true)
      handleCloseModal();
    } catch (error) {
      setAlertCustom({
        ...alertCustom,
        type: "error",
        message: error.message,
        state: true,
      });
    }
  };
  const style = {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  };
  return (
    visibility ? (
      <>
        <Box
          mt="20px"
          display="grid"
          gridTemplateColumns="repeat(2, 1fr)"
          gap="20px"
        >
          <Box sx={style}>
            <label for="my-input">REQUERIMIENTO</label>
            <TextField disabled value={buyorderRequeriment?.requeriment.date} />
          </Box>
          <Box sx={style}>
            <label for="my-input">AREA</label>
            <TextField disabled value={buyorderRequeriment?.area.description} />
          </Box>
          <Box sx={style}>
            <label for="my-input">PRIORIDAD</label>
            <TextField
              disabled
              value={buyorderRequeriment?.priority.description}
            />
          </Box>
          <Box sx={style}>
            <label for="my-input">SUBJECT</label>
            <TextField disabled value={buyorderRequeriment?.subject} />
          </Box>
          <Box sx={style}>
            <label for="my-input">FECHA DE INCORPORACIÓN</label>
            <TextField
              disabled
              value={new Date(buyorderRequeriment.createdAt).toLocaleDateString(
                "es-ES"
              )}
            />{" "}
            {/* Falta arreglar las fechas */}
          </Box>
        </Box>
        <Box my={"20px"}>
          <TableContainer style={{ maxHeight: 550, overflowY: "auto" }}>
            <Table stickyHeader aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="">N°</TableCell>
                  <TableCell align="">Activo</TableCell>
                  <TableCell align="">Descripcion</TableCell>
                  <TableCell align="">Cantidad</TableCell>
                  <TableCell align="">Observaciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {buyorderRequeriment.item.map((row, index) => (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="">{index + 1}</TableCell>
                    <TableCell align="">{row.active}</TableCell>
                    <TableCell align="">{row.description}</TableCell>
                    <TableCell align="">{row.amount}</TableCell>
                    <TableCell align="">{row.observation}</TableCell>
                  </TableRow>
                  /* </RadioGroup> */
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box my={"20px"}>
        <TextField
        label="OBSERVACION"
        variant="outlined"
        fullWidth
           multiline
          rows={6}
        value={textFieldValue}
        onChange={(event) => setTextFieldValue(event.target.value)}
      />
        </Box>
        <Box
          display={"flex"}
          justifyContent={"end"}
          marginTop={"30px"}
          gap={"20px"}
        >
          <Button
            variant="contained"
            color="error"
            disabled={!saved}
            onClick={handlePersonalRequerimentReject}
          >
              {!saved ?<LoopIcon/>: "DESAPROBAR"}
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={handlePersonalRequerimentApproved}
            disabled={!saved}
          >
              {!saved ?<LoopIcon/>: "APROBAR"}
          </Button>
          {/*  */}
        </Box>
      </>
    ):<Box sx={{display:"flex",justifyContent:"center"}}><LoopIcon/></Box>
  );
};

export default AssignBuyOrder;
